// @ts-nocheck
import { create } from 'zustand';

// ----------------------------------------------------------------------

export const useBreadcrumbStore = create()((set) => ({
  heading: '',
  links: [],

  setBreadcrumb: ({ heading, links }) => set({ heading: heading || '', links: links || [] }),

  clear: () => set({ heading: '', links: [] }),
}));
